export const PANDERR_TOKENS = {
  colors: {
    text: "#172033",
    textMuted: "#667085",
    background: "#FFFFFF",
    surface: "#F7F8FA",
    surfaceAlt: "#EEF1F4",
    border: "#E4E7EC",

    primary: "#172033",
    secondary: "#475467",

    cta: "#2563EB",
    ctaHover: "#1D4ED8",
    ctaText: "#FFFFFF",

    success: "#15803D",
    warning: "#B45309",
    danger: "#B42318",
  },

  typography: {
    headingFont: "Inter, system-ui, sans-serif",
    bodyFont: "Inter, system-ui, sans-serif",

    display: "clamp(2.75rem, 6vw, 5.75rem)",
    h1: "clamp(2.5rem, 5vw, 4.75rem)",
    h2: "clamp(2rem, 4vw, 3.5rem)",
    h3: "clamp(1.4rem, 2vw, 2rem)",
    bodyLarge: "1.125rem",
    body: "1rem",
    small: "0.875rem",

    lineHeightTight: "1.05",
    lineHeightHeading: "1.15",
    lineHeightBody: "1.7",
  },

  spacing: {
    xs: "0.5rem",
    sm: "0.75rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem",
    "3xl": "4rem",
    "4xl": "6rem",
    "5xl": "8rem",
  },

  radius: {
    small: "10px",
    medium: "16px",
    large: "24px",
    pill: "999px",
  },

  shadow: {
    subtle: "0 8px 24px rgba(16, 24, 40, 0.06)",
    card: "0 16px 40px rgba(16, 24, 40, 0.08)",
    elevated: "0 24px 60px rgba(16, 24, 40, 0.12)",
  },

  layout: {
    maxWidth: "1200px",
    wideMaxWidth: "1440px",
    contentWidth: "760px",
    gutter: "clamp(1.25rem, 4vw, 3rem)",
    sectionPadding: "clamp(4rem, 8vw, 7rem)",
  },

  image: {
    heroAspectRatio: "16 / 10",
    cardAspectRatio: "4 / 3",
    portraitAspectRatio: "4 / 5",
  },

  motion: {
    fast: "160ms ease",
    normal: "240ms ease",
  },
} as const;

export type PanderrTokens = typeof PANDERR_TOKENS;
